import { QUIZ_ROUNDS_ROUTE } from './constants';
import http from '../../../utils/httpService';

/**
 *
 * @param id
 */
const requestRounds = id => {
    const route = QUIZ_ROUNDS_ROUTE + `/${id}`;
    return http.request(route, 'GET');
};

/**
 *
 * @param formData
 * @returns {*}
 */
const requestAddRound = (formData) => {
    const route = QUIZ_ROUNDS_ROUTE;
    return http.request(route, 'POST', formData);
};

/**
 *
 * @param formData
 * @returns {*}
 */
const requestUpdateRound = (formData) => {
    const route = QUIZ_ROUNDS_ROUTE + `/${formData.id}`;
    return http.request(route, 'PUT', formData);
};

/**
 *
 * @param id
 */
const requestDeleteRound = (id) => {
    const route = QUIZ_ROUNDS_ROUTE + `/${id}`;
    return http.request(route, 'DELETE');
};

export {
    requestRounds,
    requestAddRound,
    requestUpdateRound,
    requestDeleteRound
};
